export interface IDefaultError {
  data: {
    code?: string;
    error?: string;
    message?: string;
    type?: string;
  };
}

const hasErrorData = (err: unknown): err is IDefaultError =>
  typeof err === 'object' && err !== null && 'data' in err;

const hasMessage = (err: unknown): err is { message: string } =>
  typeof err === 'object' &&
  err !== null &&
  typeof (err as { message?: unknown }).message === 'string';

export const extractErrorMessage = (err: unknown, defaultError?: string): string => {
  const data = hasErrorData(err) ? err.data : undefined;
  const error = data?.error;
  const message = data?.message;
  const fallbackMessage = hasMessage(err) ? err.message : undefined;

  if (error) return error;
  if (message) return message;
  if (fallbackMessage) return fallbackMessage;

  return defaultError || 'Unknown error occurred';
};

export const extractErrorCode = (err: unknown): string | undefined =>
  hasErrorData(err) ? err.data?.code : undefined;
